import { Alert, AlertTitle, Box, List, ListItem, Stack, Typography } from '@mui/material';
import type { HoldMultiDayResult } from 'api-client';
import { formatDateForDisplay } from '@/utils/dateUtils';

export function HoldCreationResult({ result }: { result: HoldMultiDayResult }) {
  const severity = result.createdCount === 0 ? 'error' : result.skippedCount > 0 ? 'warning' : 'success';
  return (
    <Stack spacing={1.5} aria-label="Hold creation results" aria-live="polite" sx={{ overflowWrap: 'anywhere' }}>
      <Alert severity={severity}>
        <AlertTitle>
          {result.createdCount} hold{result.createdCount === 1 ? '' : 's'} created
          {result.skippedCount > 0 ? `, ${result.skippedCount} skipped` : ''}
        </AlertTitle>
        {result.message}
      </Alert>
      <List dense disablePadding aria-label="Results by date">
        {result.outcomes.map((outcome) => (
          <ListItem key={outcome.date} disableGutters sx={{ display: 'block', py: 1 }}>
            <Typography component="div" variant="body2" fontWeight="bold">
              <Box component="time" dateTime={outcome.date}>{formatDateForDisplay(outcome.date)}</Box>
              {' — '}{outcome.status === 'created' ? 'Created' : 'Skipped'}
            </Typography>
            <Typography variant="body2" color="text.secondary">{outcome.message}</Typography>
          </ListItem>
        ))}
      </List>
      {result.createdCount > 0 && result.skippedCount > 0 && (
        <Typography variant="body2" color="text.secondary">
          The created holds are saved. Review skipped dates before making another request.
        </Typography>
      )}
    </Stack>
  );
}
